(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
(() => {
  const COPY_SELECTOR = '[data-article-copy-link]';

  function fallbackCopy(text) {
    const input = document.createElement('textarea');
    input.value = text;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.opacity = '0';
    input.style.pointerEvents = 'none';
    document.body.appendChild(input);
    input.select();

    let copied = false;
    try {
      copied = document.execCommand('copy');
    } catch (_) {
      copied = false;
    }

    input.remove();
    return copied;
  }

  async function copyText(text) {
    if (!text) return false;

    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(text);
        return true;
      } catch (_) {
        return fallbackCopy(text);
      }
    }

    return fallbackCopy(text);
  }

  function setCopiedState(button, copied) {
    if (!button) return;

    const defaultLabel = button.dataset.defaultLabel || 'Copy link';
    const successLabel = button.dataset.successLabel || 'Copied!';

    if (copied) {
      button.dataset.copied = 'true';
      button.setAttribute('aria-label', successLabel);

      window.setTimeout(() => {
        button.removeAttribute('data-copied');
        button.setAttribute('aria-label', defaultLabel);
      }, 1500);

      return;
    }

    button.removeAttribute('data-copied');
    button.setAttribute('aria-label', defaultLabel);
  }

  function bindCopyButton(button) {
    if (!button || button.dataset.copyBound === 'true') return;

    button.dataset.copyBound = 'true';

    button.addEventListener('click', async (event) => {
      event.preventDefault();

      const url = button.dataset.copyUrl || window.location.href;
      const copied = await copyText(url);
      setCopiedState(button, copied);
    });
  }

  function initCopyButtons(root = document) {
    root.querySelectorAll(COPY_SELECTOR).forEach(bindCopyButton);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initCopyButtons(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCopyButtons());
  } else {
    initCopyButtons();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
    
const ROOT_SELECTOR = '[data-countdown]';
const ACTIVE_CLASS = 'is-expired';
const DIGIT_STAGGER_MS = 50;
const DIGIT_ANIMATION_MS = 680;
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

const instances = new Map();

const toString = (value) => String(value || '').trim();

const parseDateFromSetting = (rawValue) => {
  const value = toString(rawValue);
  if (!value.length) return null;

  let parsed = new Date(value);
  if (!Number.isNaN(parsed.getTime())) return parsed;

  parsed = new Date(value.replace(' ', 'T'));
  if (!Number.isNaN(parsed.getTime())) return parsed;

  const matched = value.match(
    /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?$/
  );
  if (!matched) return null;

  const year = Number.parseInt(matched[1], 10);
  const month = Number.parseInt(matched[2], 10) - 1;
  const day = Number.parseInt(matched[3], 10);
  const hours = Number.parseInt(matched[4] || '0', 10);
  const minutes = Number.parseInt(matched[5] || '0', 10);
  const seconds = Number.parseInt(matched[6] || '0', 10);

  const fallbackDate = new Date(year, month, day, hours, minutes, seconds);
  if (Number.isNaN(fallbackDate.getTime())) return null;
  return fallbackDate;
};

const pad = (value) => String(Math.max(0, value)).padStart(2, '0');

class Countdown {
  constructor(root) {
    this.root = root;
    this.section = root.closest('.section-countdown');
    this.expiredState = toString(root.dataset.expiredState) || 'show_message';
    this.designMode = toString(root.dataset.designMode) === 'true';
    this.endDate = parseDateFromSetting(root.dataset.endDateTime);
    this.timerNode = root.querySelector('[data-countdown-timer]');
    this.expiredMessageNode = root.querySelector('[data-countdown-expired-message]');
    this.daysNode = root.querySelector('[data-countdown-days]');
    this.daysItemNode = root.querySelector('[data-countdown-days-item]');
    this.daysSeparatorNode = root.querySelector('[data-countdown-days-separator]');
    this.hoursNode = root.querySelector('[data-countdown-hours]');
    this.minutesNode = root.querySelector('[data-countdown-minutes]');
    this.secondsNode = root.querySelector('[data-countdown-seconds]');
    this.intervalId = null;
    this.isExpired = false;
    this.staggerTimers = new Set();
  }

  init() {
    this.initValueNodes();
    this.update();

    if (this.endDate && !this.isExpired) {
      this.intervalId = window.setInterval(() => this.update(), 1000);
    }
  }

  destroy() {
    if (this.intervalId !== null) {
      window.clearInterval(this.intervalId);
      this.intervalId = null;
    }

    this.staggerTimers.forEach((timerId) => window.clearTimeout(timerId));
    this.staggerTimers.clear();

    this.getValueNodes().forEach((node) => {
      if (!(node instanceof HTMLElement)) return;
      node.querySelectorAll('.countdown__digit-slot').forEach((slot) => {
        window.clearTimeout(slot.__staggerTimer);
        window.clearTimeout(slot.__cleanupTimer);
      });
    });
  }

  update() {
    if (!this.endDate) {
      this.renderTime(0);
      return;
    }

    const now = Date.now();
    const diff = this.endDate.getTime() - now;

    if (diff <= 0) {
      this.handleExpired();
      return;
    }

    this.renderTime(diff);
  }

  handleExpired() {
    if (this.isExpired) return;
    this.isExpired = true;
    this.root.classList.add(ACTIVE_CLASS);

    this.renderTime(0);

    if (this.expiredState === 'hide_section' && !this.designMode) {
      if (this.section) {
        this.section.hidden = true;
      }
      this.destroy();
      return;
    }

    if (this.timerNode) {
      this.timerNode.hidden = true;
    }

    if (this.expiredMessageNode) {
      this.expiredMessageNode.hidden = false;
    }

    this.destroy();
  }

  initValueNodes() {
    this.getValueNodes().forEach((node) => {
      if (!node) return;
      if (node.dataset.countdownEnhanced === 'true') return;

      const initialValue = (toString(node.textContent) || '00').padStart(2, '0');
      const tensSlot = this.createDigitSlot(initialValue.charAt(0));
      const onesSlot = this.createDigitSlot(initialValue.charAt(1));

      node.textContent = '';
      node.append(tensSlot, onesSlot);
      node.dataset.countdownEnhanced = 'true';
      node.dataset.countdownValue = initialValue;
    });
  }

  createDigitSlot(initialDigit) {
    const slot = document.createElement('span');
    slot.className = 'countdown__digit-slot';

    const glyph = document.createElement('span');
    glyph.className = 'countdown__digit-glyph';
    glyph.dataset.countdownCurrent = 'true';
    glyph.textContent = initialDigit;

    slot.append(glyph);
    return slot;
  }

  getValueNodes() {
    return [this.daysNode, this.hoursNode, this.minutesNode, this.secondsNode];
  }

  getCurrentGlyph(slot) {
    if (!(slot instanceof HTMLElement)) return null;

    const glyphs = Array.from(slot.querySelectorAll('.countdown__digit-glyph'));
    let currentGlyph = glyphs.find((glyph) => glyph.dataset.countdownCurrent === 'true');
    if (!(currentGlyph instanceof HTMLElement)) {
      currentGlyph = glyphs[glyphs.length - 1] || null;
    }

    if (!(currentGlyph instanceof HTMLElement)) {
      currentGlyph = document.createElement('span');
      currentGlyph.className = 'countdown__digit-glyph';
      currentGlyph.textContent = '0';
      slot.replaceChildren(currentGlyph);
    }

    currentGlyph.dataset.countdownCurrent = 'true';
    currentGlyph.classList.remove(
      'countdown__digit-glyph--exit',
      'countdown__digit-glyph--enter',
      'countdown__digit-glyph--enter-start'
    );
    currentGlyph.style.removeProperty('animation-delay');

    glyphs.forEach((glyph) => {
      if (glyph !== currentGlyph) glyph.remove();
    });

    return currentGlyph;
  }

  setUnitValue(node, numericValue) {
    if (!(node instanceof HTMLElement)) return;

    const normalizedValue = pad(numericValue);
    const currentValue = node.dataset.countdownValue;
    if (currentValue === normalizedValue) return;

    const slots = node.querySelectorAll('.countdown__digit-slot');
    if (slots.length !== normalizedValue.length) {
      node.textContent = '';
      node.append(...normalizedValue.split('').map((digit) => this.createDigitSlot(digit)));
      node.dataset.countdownValue = normalizedValue;
      return;
    }

    const previousValue = (currentValue || '').padStart(normalizedValue.length, '0');

    let cascadeDelay = 0;
    let inCascade = false;
    for (let i = 0; i < normalizedValue.length; i += 1) {
      if (previousValue.charAt(i) === normalizedValue.charAt(i)) {
        inCascade = false;
        continue;
      }
      this.animateDigitSlot(slots[i], normalizedValue.charAt(i), inCascade ? cascadeDelay : 0);
      cascadeDelay += DIGIT_STAGGER_MS;
      inCascade = true;
    }

    node.dataset.countdownValue = normalizedValue;
  }

  animateDigitSlot(slot, nextDigit, delayMs) {
    if (!(slot instanceof HTMLElement)) return;

    window.clearTimeout(slot.__staggerTimer);
    window.clearTimeout(slot.__cleanupTimer);
    slot.__pendingDigit = nextDigit;

    const run = () => {
      if (!slot.isConnected) return;
      if (slot.__pendingDigit !== nextDigit) return;

      const currentGlyph = this.getCurrentGlyph(slot);
      if (!(currentGlyph instanceof HTMLElement)) return;
      if (toString(currentGlyph.textContent) === nextDigit) return;

      if (reducedMotion.matches) {
        currentGlyph.textContent = nextDigit;
        return;
      }

      currentGlyph.dataset.countdownCurrent = 'false';
      const exitGlyph = currentGlyph;
      const enterGlyph = document.createElement('span');
      enterGlyph.className = 'countdown__digit-glyph countdown__digit-glyph--enter countdown__digit-glyph--enter-start';
      enterGlyph.dataset.countdownCurrent = 'true';
      enterGlyph.textContent = nextDigit;

      slot.append(enterGlyph);

      exitGlyph.classList.add('countdown__digit-glyph--exit');

      exitGlyph.addEventListener(
        'animationend',
        () => {
          exitGlyph.remove();
        },
        { once: true }
      );

      enterGlyph.addEventListener(
        'animationend',
        () => {
          enterGlyph.classList.remove('countdown__digit-glyph--enter', 'countdown__digit-glyph--enter-start');
        },
        { once: true }
      );

      slot.__cleanupTimer = window.setTimeout(() => {
        const activeGlyph = this.getCurrentGlyph(slot);
        if (activeGlyph) {
          activeGlyph.textContent = nextDigit;
        }
      }, DIGIT_ANIMATION_MS + 120);
    };

    if (delayMs > 0 && !reducedMotion.matches) {
      slot.__staggerTimer = window.setTimeout(() => {
        const timerId = slot.__staggerTimer;
        this.staggerTimers.delete(timerId);
        slot.__staggerTimer = null;
        run();
      }, delayMs);
      this.staggerTimers.add(slot.__staggerTimer);
      return;
    }

    run();
  }

  toggleDaysVisibility(days) {
    const showDays = days > 0;
    if (this.daysItemNode) {
      this.daysItemNode.hidden = !showDays;
    }
    if (this.daysSeparatorNode) {
      this.daysSeparatorNode.hidden = !showDays;
    }
  }

  renderTime(remainingMs) {
    const totalSeconds = Math.max(0, Math.floor(remainingMs / 1000));
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    this.toggleDaysVisibility(days);
    this.setUnitValue(this.daysNode, days);
    this.setUnitValue(this.hoursNode, hours);
    this.setUnitValue(this.minutesNode, minutes);
    this.setUnitValue(this.secondsNode, seconds);
  }
}

const initRoot = (root) => {
  if (!root || instances.has(root)) return;
  const instance = new Countdown(root);
  instance.init();
  instances.set(root, instance);
};

const destroyRoot = (root) => {
  const instance = instances.get(root);
  if (!instance) return;
  instance.destroy();
  instances.delete(root);
};

const initAll = (scope = document) => {
  scope.querySelectorAll(ROOT_SELECTOR).forEach((node) => initRoot(node));
};

const destroyIn = (sectionRoot) => {
  if (!sectionRoot) return;
  sectionRoot.querySelectorAll(ROOT_SELECTOR).forEach((node) => destroyRoot(node));
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initAll());
} else {
  initAll();
}

document.addEventListener('shopify:section:load', (event) => {
  const sectionRoot = event.target.closest('.shopify-section') || event.target;
  destroyIn(sectionRoot);
  initAll(sectionRoot);
});

document.addEventListener('shopify:section:unload', (event) => {
  const sectionRoot = event.target.closest('.shopify-section') || event.target;
  destroyIn(sectionRoot);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-scroll"] && !Shopify.designMode) return;
  try {
    
(() => {
  const ROOT_SELECTOR = '[data-editorial-scroll]';
  const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
  const NORMAL_LAYOUT_BREAKPOINT = 1100;
  const controllers = new Map();
  const reducedMotionMedia = window.matchMedia(REDUCED_MOTION_QUERY);

  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  const alignToDevicePixel = (value) => {
    const dpr = Math.max(window.devicePixelRatio || 1, 1);
    return Math.round(value * dpr) / dpr;
  };

  class Spring {
    constructor(stiffness = 120, damping = 30, mass = 0.72) {
      this.stiffness = stiffness;
      this.damping = damping;
      this.mass = mass;
      this.value = 0;
      this.target = 0;
      this.velocity = 0;
    }

    setTarget(target) {
      this.target = target;
    }

    set(value) {
      this.value = value;
      this.target = value;
      this.velocity = 0;
    }

    step(deltaTime) {
      const dt = Math.min(deltaTime, 0.064);
      const displacement = this.value - this.target;
      const springForce = -this.stiffness * displacement;
      const dampingForce = -this.damping * this.velocity;
      const acceleration = (springForce + dampingForce) / this.mass;

      this.velocity += acceleration * dt;
      this.value += this.velocity * dt;

      return this.value;
    }
  }

  class EditorialScrollController {
    constructor(root) {
      this.root = root;
      this.stage = root.querySelector('[data-editorial-stage]');
      this.viewport = root.querySelector('.editorial-scroll__viewport');
      this.strip = root.querySelector('[data-editorial-strip]');
      this.headingLayer = root.querySelector('[data-editorial-heading-layer]');
      this.baseCards = Array.from(root.querySelectorAll('[data-editorial-card]'));
      this.cards = this.baseCards;

      this.stiffness = Number(root.dataset.stiffness) || 120;
      this.revealEnabled = root.dataset.revealEnabled !== 'false';
      this.headingBehind = root.dataset.headingBehind === 'true';

      this.motionReduced = reducedMotionMedia.matches;
      this.spring = this.createSpring();

      this.cardWidth = 280;
      this.cardSpacing = 480;
      this.stripWidth = 0;
      this.totalDistance = 0;
      this.progress = 0;
      this.targetX = 0;
      this.currentX = 0;
      this.targetHeadingOpacity = 1;
      this.currentHeadingOpacity = 1;
      this.isScrolling = false;
      this.rafId = 0;
      this.lastFrame = 0;
      this.scrollIdleTimer = 0;
      this.meta = [];
      this.isTickerMode = false;
      this.tickerOffset = 0;
      this.tickerSpeed = 0;
      this.tickerDistance = 0;
      // Track the last viewport width so the resize handler can ignore
      // height-only resize events. On mobile, the browser fires `resize`
      // when the URL bar / bottom toolbar collapses during scroll — those
      // are HEIGHT changes only, but if we treat them as real layout
      // changes the ticker rebuild resets tickerOffset to 0 and the
      // ticker visibly snaps back to the start every time the user
      // scrolls. We only need to rebuild when WIDTH actually changes
      // (orientation flip, real responsive boundary, etc).
      this.lastViewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.tick = this.tick.bind(this);

      // IO-cached visibility — avoids per-scroll getBoundingClientRect calls
      // for the (common) case where the editorial section is far off-screen.
      this.visibilityObserver = null;
      this.isInViewportRange = true;
    }

    createSpring() {
      const stiffness = clamp(this.stiffness, 40, 200);
      const damping = Math.round(stiffness * 0.28);
      return new Spring(stiffness, damping, 0.72);
    }

    init() {
      if (!this.stage || !this.strip || this.baseCards.length === 0) {
        return false;
      }

      if (!this.revealEnabled) {
        this.baseCards.forEach((card) => card.classList.add('is-revealed'));
      }

      this.isTickerMode = this.isTickerViewport();
      this.root.dataset.editorialMode = this.isTickerMode ? 'ticker' : 'scroll';
      this.recalculateLayout();
      this.syncToProgress();
      if (this.isTickerMode) {
        this.applyTickerFrame(this.tickerOffset);
      } else {
        this.applyFrame(this.targetX, this.targetHeadingOpacity);
      }

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });

      if (typeof window.IntersectionObserver === 'function') {
        this.isInViewportRange = false;
        this.visibilityObserver = new IntersectionObserver((entries) => {
          this.isInViewportRange = entries.some((entry) => entry.isIntersecting);
          if (this.isInViewportRange && !this.isTickerMode && !this.motionReduced) {
            this.syncToProgress();
            this.startAnimationLoop();
          }
        }, { rootMargin: '480px 0px 480px 0px', threshold: 0 });
        this.visibilityObserver.observe(this.stage);
      }

      if (this.isTickerMode && !this.motionReduced) {
        this.startAnimationLoop();
      }
      return true;
    }

    destroy() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);

      if (this.visibilityObserver) {
        this.visibilityObserver.disconnect();
        this.visibilityObserver = null;
      }

      if (this.scrollIdleTimer) {
        window.clearTimeout(this.scrollIdleTimer);
        this.scrollIdleTimer = 0;
      }

      if (this.rafId) {
        window.cancelAnimationFrame(this.rafId);
        this.rafId = 0;
      }

      this.removeTickerClones();
      this.strip.style.removeProperty('width');
      this.strip.style.removeProperty('transform');

      if (this.headingLayer) {
        this.headingLayer.style.removeProperty('--editorial-heading-opacity');
      }

      this.cards.forEach((card) => {
        card.style.removeProperty('left');
        card.classList.remove('is-revealed');
      });

      this.root.removeAttribute('data-editorial-mode');
    }

    setReducedMotionState(enabled) {
      this.motionReduced = enabled;
      this.spring = this.createSpring();
      this.spring.set(this.currentX);
      this.recalculateLayout();
      if (this.isTickerMode) {
        if (this.motionReduced && this.rafId) {
          window.cancelAnimationFrame(this.rafId);
          this.rafId = 0;
          this.tickerOffset = 0;
          this.applyTickerFrame(this.tickerOffset);
        }
        if (!this.motionReduced) {
          this.startAnimationLoop();
        }
        return;
      }
      this.syncToProgress();
      this.applyFrame(this.targetX, this.targetHeadingOpacity);
    }

    recalculateLayout() {
      if (this.isTickerMode) {
        this.baseCards.forEach((card) => {
          card.style.removeProperty('left');
          card.classList.add('is-revealed');
        });
        this.meta = this.baseCards.map((card) => ({ card, left: 0 }));
        this.strip.style.removeProperty('width');
        this.totalDistance = 0;
        this.targetX = 0;
        this.currentX = 0;
        this.targetHeadingOpacity = 1;
        this.currentHeadingOpacity = 1;
        this.spring.set(0);
        this.setupTickerTrack();
        return;
      }

      this.removeTickerClones();
      const computed = window.getComputedStyle(this.root);
      this.cardWidth = parseFloat(computed.getPropertyValue('--editorial-card-width')) || 280;
      this.cardSpacing = parseFloat(computed.getPropertyValue('--editorial-card-spacing')) || 480;

      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      const startOffset = clamp(viewportWidth * 0.08, 24, 160);

      let maxCardStart = startOffset;

      this.meta = this.baseCards.map((card, index) => {
        const jitter = parseFloat(card.dataset.jitter || '0') || 0;
        const left = startOffset + this.cardSpacing * index + jitter;
        card.style.left = `${left}px`;
        maxCardStart = Math.max(maxCardStart, left);
        return {
          card,
          left
        };
      });

      this.stripWidth = maxCardStart + this.cardWidth + startOffset;
      this.strip.style.width = `${Math.ceil(this.stripWidth)}px`;
      this.totalDistance = Math.max(0, this.stripWidth - viewportWidth + startOffset * 0.5);

      this.targetX = clamp(this.targetX, -this.totalDistance, 0);
      this.currentX = clamp(this.currentX, -this.totalDistance, 0);
      this.spring.set(this.currentX);
    }

    getProgress() {
      if (this.isTickerMode) {
        return 0;
      }

      const rect = this.stage.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const totalScrollableHeight = this.stage.offsetHeight - viewportHeight;

      if (totalScrollableHeight <= 0) {
        return 0;
      }

      return clamp(-rect.top / totalScrollableHeight, 0, 1);
    }

    isStageInView() {
      const rect = this.stage.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      return rect.bottom > 0 && rect.top < viewportHeight;
    }

    resetReveals() {
      this.meta.forEach(({ card }) => {
        card.classList.remove('is-revealed');
      });
    }

    getHeadingOpacity(progress) {
      if (!this.headingLayer || !this.headingBehind) {
        return 1;
      }

      if (progress <= 0.03) {
        return 1;
      }

      if (progress >= 0.16) {
        return 0;
      }

      return 1 - (progress - 0.03) / 0.13;
    }

    syncToProgress() {
      if (this.isTickerMode) {
        this.progress = 0;
        this.targetX = 0;
        this.targetHeadingOpacity = 1;
        return;
      }

      this.progress = this.getProgress();
      this.targetX = -this.totalDistance * this.progress;
      this.targetHeadingOpacity = this.getHeadingOpacity(this.progress);
      this.spring.setTarget(this.targetX);
    }

    onScroll() {
      if (this.isTickerMode) {
        return;
      }

      // IO-gated short-circuit. When the section is far off-screen we skip
      // syncToProgress (which calls getBoundingClientRect) and the rAF loop
      // entirely; the IO callback re-arms us when the section returns.
      if (this.visibilityObserver && !this.isInViewportRange) {
        return;
      }

      this.isScrolling = true;
      this.syncToProgress();
      this.startAnimationLoop();

      if (this.scrollIdleTimer) {
        window.clearTimeout(this.scrollIdleTimer);
      }

      this.scrollIdleTimer = window.setTimeout(() => {
        this.isScrolling = false;
      }, 120);
    }

    onResize() {
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
      const nextTickerMode = this.isTickerViewport();
      const modeChanged = nextTickerMode !== this.isTickerMode;
      const widthChanged = viewportWidth !== this.lastViewportWidth;

      // Mobile address-bar / bottom-toolbar collapse fires resize events
      // with no width change — re-running recalculateLayout() in ticker
      // mode would call setupTickerTrack() and reset tickerOffset to 0,
      // making the ticker visibly snap back to the start while the user
      // scrolls. Bail early when only the height changed and we're
      // staying in ticker mode.
      if (this.isTickerMode && !modeChanged && !widthChanged) {
        return;
      }

      if (modeChanged) {
        this.isTickerMode = nextTickerMode;
        this.root.dataset.editorialMode = this.isTickerMode ? 'ticker' : 'scroll';
      }

      this.lastViewportWidth = viewportWidth;
      this.recalculateLayout();
      this.syncToProgress();

      if (this.isTickerMode) {
        if (this.motionReduced) {
          this.tickerOffset = 0;
          this.applyTickerFrame(this.tickerOffset);
          if (this.rafId) {
            window.cancelAnimationFrame(this.rafId);
            this.rafId = 0;
          }
          return;
        }

        this.startAnimationLoop();
        return;
      }

      if (this.motionReduced) {
        this.currentX = this.targetX;
        this.currentHeadingOpacity = this.targetHeadingOpacity;
        this.applyFrame(this.currentX, this.currentHeadingOpacity);
        return;
      }

      this.startAnimationLoop();
    }

    startAnimationLoop() {
      if (this.rafId) {
        return;
      }

      this.lastFrame = 0;
      this.rafId = window.requestAnimationFrame(this.tick);
    }

    tick(timestamp) {
      const delta = this.lastFrame ? (timestamp - this.lastFrame) / 1000 : 0.016;
      this.lastFrame = timestamp;

      if (this.isTickerMode) {
        if (!this.motionReduced && this.tickerDistance > 0) {
          if (!document.hidden && this.isStageInView()) {
            this.tickerOffset -= this.tickerSpeed * delta;
            while (this.tickerOffset <= -this.tickerDistance) {
              this.tickerOffset += this.tickerDistance;
            }
          }
          this.applyTickerFrame(this.tickerOffset);
          this.rafId = window.requestAnimationFrame(this.tick);
          return;
        }

        {
          this.tickerOffset = 0;
          this.applyTickerFrame(this.tickerOffset);
          this.rafId = 0;
          return;
        }
      }

      if (this.motionReduced) {
        this.currentX = this.targetX;
        this.currentHeadingOpacity = this.targetHeadingOpacity;
      } else {
        this.currentX = this.spring.step(delta);
        this.currentX = clamp(this.currentX, -this.totalDistance, 0);
        this.currentHeadingOpacity += (this.targetHeadingOpacity - this.currentHeadingOpacity) * 0.18;
      }

      this.applyFrame(this.currentX, this.currentHeadingOpacity);

      const moving = Math.abs(this.currentX - this.targetX) > 0.25;
      const headingMoving = Math.abs(this.currentHeadingOpacity - this.targetHeadingOpacity) > 0.01;

      if (this.isScrolling || moving || headingMoving) {
        this.rafId = window.requestAnimationFrame(this.tick);
      } else {
        this.rafId = 0;
      }
    }

    applyFrame(translateX, headingOpacity) {
      const alignedX = alignToDevicePixel(translateX);
      this.strip.style.transform = `translate3d(${alignedX.toFixed(2)}px, 0, 0)`;

      if (this.headingLayer) {
        this.headingLayer.style.setProperty('--editorial-heading-opacity', headingOpacity.toFixed(3));
      }

      if (this.revealEnabled) {
        this.updateReveals(translateX);
      }
    }

    applyTickerFrame(offset) {
      const alignedOffset = alignToDevicePixel(offset);
      this.strip.style.transform = `translate3d(${alignedOffset.toFixed(2)}px, 0, 0)`;

      if (this.headingLayer) {
        this.headingLayer.style.setProperty('--editorial-heading-opacity', '1');
      }
    }

    updateReveals(translateX) {
      if (!this.isStageInView()) {
        this.resetReveals();
        return;
      }

      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      const threshold = Math.min(this.cardWidth * 0.4, 120);

      this.meta.forEach(({ card, left }) => {
        const cardLeft = left + translateX;
        const cardRight = cardLeft + this.cardWidth;
        const visible = cardRight > -threshold && cardLeft < viewportWidth + threshold;

        if (visible) {
          card.classList.add('is-revealed');
        } else {
          card.classList.remove('is-revealed');
        }
      });
    }

    isTickerViewport() {
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      return viewportWidth <= NORMAL_LAYOUT_BREAKPOINT;
    }

    removeTickerClones() {
      this.strip.querySelectorAll('[data-editorial-clone]').forEach((node) => node.remove());
    }

    setupTickerTrack() {
      this.removeTickerClones();

      this.baseCards.forEach((card) => card.classList.add('is-revealed'));
      if (this.motionReduced || this.baseCards.length === 0) {
        this.tickerDistance = 0;
        this.tickerOffset = 0;
        this.tickerSpeed = 0;
        this.strip.style.transform = 'translate3d(0px, 0, 0)';
        return;
      }

      const stripStyle = window.getComputedStyle(this.strip);
      const gap = parseFloat(stripStyle.columnGap || stripStyle.gap || '0') || 0;
      const firstCardRect = this.baseCards[0].getBoundingClientRect();
      const lastCardRect = this.baseCards[this.baseCards.length - 1].getBoundingClientRect();
      const baseSetWidth = Math.max(0, lastCardRect.right - firstCardRect.left + gap);
      const viewportWidth = this.viewportWidth();

      this.tickerDistance = baseSetWidth;
      this.tickerOffset = 0;
      this.tickerSpeed = clamp(this.stiffness * 0.55, 42, 112);

      if (baseSetWidth <= 0 || viewportWidth <= 0) {
        this.tickerDistance = 0;
        return;
      }

      const cloneLimit = 36;
      let safetyCounter = 0;
      while (this.strip.scrollWidth < viewportWidth * 2 + baseSetWidth && safetyCounter < cloneLimit) {
        this.baseCards.forEach((card) => {
          const clone = card.cloneNode(true);
          clone.setAttribute('data-editorial-clone', 'true');
          clone.setAttribute('aria-hidden', 'true');
          this.strip.appendChild(clone);
        });
        safetyCounter += this.baseCards.length;
      }
    }

    viewportWidth() {
      return this.viewport?.clientWidth || window.innerWidth || document.documentElement.clientWidth;
    }
  }

  const mount = (root) => {
    if (!root || controllers.has(root)) {
      return;
    }

    const controller = new EditorialScrollController(root);
    if (!controller.init()) {
      return;
    }

    controllers.set(root, controller);
  };

  const unmount = (root) => {
    const controller = controllers.get(root);
    if (!controller) {
      return;
    }

    controller.destroy();
    controllers.delete(root);
  };

  const getRoots = (scope = document) => {
    const roots = [];
    if (scope.matches && scope.matches(ROOT_SELECTOR)) {
      roots.push(scope);
    }
    if (scope.querySelectorAll) {
      roots.push(...scope.querySelectorAll(ROOT_SELECTOR));
    }
    return roots;
  };

  const mountAll = (scope = document) => {
    getRoots(scope).forEach(mount);
  };

  const unmountAll = (scope = document) => {
    getRoots(scope).forEach(unmount);
  };

  const onReducedMotionChange = () => {
    controllers.forEach((controller) => {
      controller.setReducedMotionState(reducedMotionMedia.matches);
    });
  };

  const init = () => {
    mountAll(document);

    if (typeof reducedMotionMedia.addEventListener === 'function') {
      reducedMotionMedia.addEventListener('change', onReducedMotionChange);
    } else if (typeof reducedMotionMedia.addListener === 'function') {
      reducedMotionMedia.addListener(onReducedMotionChange);
    }

    document.addEventListener('shopify:section:load', (event) => {
      mountAll(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      unmountAll(event.target);
    });
  };

  if (!window.ThemeEditorialScroll || !window.ThemeEditorialScroll.initialized) {
    init();
    window.ThemeEditorialScroll = {
      initialized: true,
      mountAll,
      unmountAll
    };
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-comparison"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';

  if (window.__themeImageComparisonControllerInitialized) return;
  window.__themeImageComparisonControllerInitialized = true;

  const ROOT_SELECTOR = '[data-image-comparison]';
  const RANGE_SELECTOR = '.image-comparison__range';
  const ACTIVE_DRAG_CLASS = 'is-dragging';
  const HORIZONTAL_LOCK_CLASS = 'theme-horizontal-pan-lock';
  const controllers = new Map();
  let activeHorizontalPanLocks = 0;

  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  const setHorizontalPanLock = (shouldLock) => {
    const rootElement = document.documentElement;
    const bodyElement = document.body;
    if (!rootElement || !bodyElement) return;

    if (shouldLock) {
      activeHorizontalPanLocks += 1;
    } else if (activeHorizontalPanLocks > 0) {
      activeHorizontalPanLocks -= 1;
    }

    const isLocked = activeHorizontalPanLocks > 0;
    rootElement.classList.toggle(HORIZONTAL_LOCK_CLASS, isLocked);
    bodyElement.classList.toggle(HORIZONTAL_LOCK_CLASS, isLocked);
  };

  class ImageComparisonController {
    constructor(root) {
      this.root = root;
      this.range = null;
      this.hoverEnabled = false;
      this.dragEnabled = true;
      this.isPointerDragging = false;
      this.activePointerId = null;
      this.pendingPointerX = null;
      this.pointerRaf = 0;

      this.onRangeInput = this.onRangeInput.bind(this);
      this.onRangePointerDown = this.onRangePointerDown.bind(this);
      this.onRangePointerUp = this.onRangePointerUp.bind(this);
      this.onRangeBlur = this.onRangeBlur.bind(this);
      this.onRootPointerDown = this.onRootPointerDown.bind(this);
      this.onRootPointerMove = this.onRootPointerMove.bind(this);
      this.onRootPointerUp = this.onRootPointerUp.bind(this);
      this.onRootPointerLeave = this.onRootPointerLeave.bind(this);
      this.flushPendingPointerX = this.flushPendingPointerX.bind(this);
    }

    init() {
      this.range = this.root.querySelector(RANGE_SELECTOR);
      if (!this.range) return false;

      const prefersHover =
        this.root.dataset.interaction === 'hover' ||
        this.root.dataset.interaction === 'drag_hover';

      const supportsFineHover = window.matchMedia(
        '(hover: hover) and (pointer: fine)'
      ).matches;

      this.hoverEnabled = prefersHover && supportsFineHover;
      this.dragEnabled =
        this.root.dataset.interaction === 'drag' ||
        this.root.dataset.interaction === 'drag_hover' ||
        !this.hoverEnabled;

      if (!this.dragEnabled) {
        this.root.classList.remove(ACTIVE_DRAG_CLASS);
      }

      if (this.root.dataset.interaction === 'hover' && !this.hoverEnabled) {
        // Fallback to drag on touch/coarse pointers.
        this.root.dataset.interaction = 'drag';
      }

      const initialFromDataset = Number.parseFloat(this.root.dataset.initialPosition || '50');
      const initialFromRange = Number.parseFloat(this.range.value || '50');
      const initial = Number.isFinite(initialFromDataset)
        ? initialFromDataset
        : Number.isFinite(initialFromRange)
          ? initialFromRange
          : 50;

      this.setPosition(initial, { syncRange: true });

      this.range.addEventListener('input', this.onRangeInput);
      this.range.addEventListener('change', this.onRangeInput);
      this.range.addEventListener('blur', this.onRangeBlur);

      if (this.dragEnabled) {
        this.range.addEventListener('pointerdown', this.onRangePointerDown);
        this.range.addEventListener('pointerup', this.onRangePointerUp);
        this.range.addEventListener('pointercancel', this.onRangePointerUp);
        this.root.addEventListener('pointerdown', this.onRootPointerDown);
        this.root.addEventListener('pointermove', this.onRootPointerMove);
        this.root.addEventListener('pointerup', this.onRootPointerUp);
        this.root.addEventListener('pointercancel', this.onRootPointerUp);
        this.root.addEventListener('lostpointercapture', this.onRootPointerUp);
      }

      if (this.hoverEnabled && !this.dragEnabled) {
        this.root.addEventListener('pointermove', this.onRootPointerMove);
        this.root.addEventListener('pointerleave', this.onRootPointerLeave);
      }

      return true;
    }

    destroy() {
      if (!this.range) return;

      this.range.removeEventListener('input', this.onRangeInput);
      this.range.removeEventListener('change', this.onRangeInput);
      this.range.removeEventListener('blur', this.onRangeBlur);
      this.range.removeEventListener('pointerdown', this.onRangePointerDown);
      this.range.removeEventListener('pointerup', this.onRangePointerUp);
      this.range.removeEventListener('pointercancel', this.onRangePointerUp);
      this.root.removeEventListener('pointerdown', this.onRootPointerDown);
      this.root.removeEventListener('pointermove', this.onRootPointerMove);
      this.root.removeEventListener('pointerup', this.onRootPointerUp);
      this.root.removeEventListener('pointercancel', this.onRootPointerUp);
      this.root.removeEventListener('lostpointercapture', this.onRootPointerUp);

      this.root.removeEventListener('pointerleave', this.onRootPointerLeave);
      this.finishPointerDrag();
      this.root.classList.remove(ACTIVE_DRAG_CLASS);
    }

    onRangeInput(event) {
      const next = Number.parseFloat(event.currentTarget.value);
      this.setPosition(next, { syncRange: false });
    }

    onRangePointerDown() {
      if (!this.dragEnabled) return;
      this.root.classList.add(ACTIVE_DRAG_CLASS);
    }

    onRangePointerUp() {
      this.root.classList.remove(ACTIVE_DRAG_CLASS);
    }

    onRangeBlur() {
      this.root.classList.remove(ACTIVE_DRAG_CLASS);
    }

    onRootPointerDown(event) {
      if (!this.dragEnabled) return;
      if (this.isPointerDragging) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      this.startPointerDrag(event.pointerId);
      this.enqueuePointerX(event.clientX);

      if (typeof this.root.setPointerCapture === 'function') {
        this.root.setPointerCapture(event.pointerId);
      }

      if (this.range && typeof this.range.focus === 'function') {
        this.range.focus({ preventScroll: true });
      }

      event.preventDefault();
    }

    onRootPointerMove(event) {
      if (this.isPointerDragging) {
        if (
          this.activePointerId !== null &&
          event.pointerId !== this.activePointerId
        ) {
          return;
        }

        this.enqueuePointerX(event.clientX);
        event.preventDefault();
        return;
      }

      if (!this.hoverEnabled) return;
      if (event.pointerType === 'touch') return;
      if (this.dragEnabled && event.buttons > 0) return;

      const rect = this.root.getBoundingClientRect();
      if (rect.width <= 0) return;

      const raw = ((event.clientX - rect.left) / rect.width) * 100;
      this.setPosition(raw, { syncRange: true });
    }

    onRootPointerUp(event) {
      if (!this.dragEnabled || !this.isPointerDragging) return;
      const hasPointerId = event && typeof event.pointerId === 'number';
      if (
        hasPointerId &&
        this.activePointerId !== null &&
        event.pointerId !== this.activePointerId
      ) {
        return;
      }

      this.finishPointerDrag();
    }

    onRootPointerLeave() {
      if (this.isPointerDragging) return;
      this.root.classList.remove(ACTIVE_DRAG_CLASS);
    }

    startPointerDrag(pointerId) {
      if (this.isPointerDragging) return;
      this.isPointerDragging = true;
      this.activePointerId = pointerId;
      this.root.classList.add(ACTIVE_DRAG_CLASS);
      this.root.setAttribute('data-lenis-prevent', '');
      setHorizontalPanLock(true);
    }

    finishPointerDrag() {
      const wasPointerDragging = this.isPointerDragging;
      this.isPointerDragging = false;
      this.activePointerId = null;
      this.pendingPointerX = null;

      if (this.pointerRaf) {
        window.cancelAnimationFrame(this.pointerRaf);
        this.pointerRaf = 0;
      }

      if (wasPointerDragging) {
        setHorizontalPanLock(false);
      }

      this.root.removeAttribute('data-lenis-prevent');
      this.root.classList.remove(ACTIVE_DRAG_CLASS);
    }

    enqueuePointerX(clientX) {
      this.pendingPointerX = clientX;
      if (this.pointerRaf) return;

      this.pointerRaf = window.requestAnimationFrame(this.flushPendingPointerX);
    }

    flushPendingPointerX() {
      this.pointerRaf = 0;
      if (this.pendingPointerX === null) return;

      const rect = this.root.getBoundingClientRect();
      if (rect.width <= 0) return;

      const raw = ((this.pendingPointerX - rect.left) / rect.width) * 100;
      this.pendingPointerX = null;
      this.setPosition(raw, { syncRange: true });
    }

    setPosition(value, { syncRange }) {
      const clamped = clamp(Number.isFinite(value) ? value : 50, 0, 100);
      const positionValue = `${clamped}%`;

      this.root.style.setProperty('--image-comparison-position', positionValue);
      this.root.dataset.currentPosition = String(Math.round(clamped));

      if (syncRange && this.range) {
        this.range.value = String(Math.round(clamped));
      }
    }
  }

  const initRoot = (root) => {
    if (!root || controllers.has(root)) return;

    const controller = new ImageComparisonController(root);
    if (controller.init()) {
      controllers.set(root, controller);
    }
  };

  const destroyRoot = (root) => {
    const controller = controllers.get(root);
    if (!controller) return;

    controller.destroy();
    controllers.delete(root);
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
  };

  const destroyInSection = (sectionRoot) => {
    if (!sectionRoot) return;
    sectionRoot.querySelectorAll(ROOT_SELECTOR).forEach(destroyRoot);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const sectionRoot = event.target.closest('.shopify-section') || event.target;
    if (!sectionRoot) return;

    destroyInSection(sectionRoot);
    initAll(sectionRoot);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const sectionRoot = event.target.closest('.shopify-section') || event.target;
    destroyInSection(sectionRoot);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';

  if (window.__themeRichTextCursorRevealInitialized) return;
  window.__themeRichTextCursorRevealInitialized = true;

  const ROOT_SELECTOR = '[data-rt-cursor-reveal-root]';
  const HOVER_BLOCKERS_SELECTOR = '[data-rt-cursor-block]';
  const DESKTOP_CURSOR_QUERY = '(min-width: 700px) and (hover: hover) and (pointer: fine)';
  const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
  const controllers = new Map();

  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

  class RichTextCursorRevealController {
    constructor(root) {
      this.root = root;
      this.layer = root.querySelector('[data-rt-cursor-layer]');
      this.card = root.querySelector('[data-rt-cursor-card]');
      this.rect = null;
      this.cardHalfWidth = 0;
      this.cardHalfHeight = 0;
      this.active = false;
      this.visible = false;
      this.rafId = null;
      this.targetX = 0;
      this.targetY = 0;
      this.currentX = 0;
      this.currentY = 0;
      this.lerp = 0.14;

      this.onMouseEnter = this.onMouseEnter.bind(this);
      this.onMouseMove = this.onMouseMove.bind(this);
      this.onMouseLeave = this.onMouseLeave.bind(this);
      this.onResizeOrScroll = this.onResizeOrScroll.bind(this);
      this.tick = this.tick.bind(this);
    }

    canRun() {
      if (!this.layer || !this.card) return false;
      if (!window.matchMedia(DESKTOP_CURSOR_QUERY).matches) return false;
      if (window.matchMedia(REDUCED_MOTION_QUERY).matches) return false;
      return true;
    }

    init() {
      if (!this.canRun()) return false;

      this.updateMetrics();
      this.root.addEventListener('mouseenter', this.onMouseEnter);
      this.root.addEventListener('mousemove', this.onMouseMove, { passive: true });
      this.root.addEventListener('mouseleave', this.onMouseLeave);
      window.addEventListener('resize', this.onResizeOrScroll, { passive: true });
      window.addEventListener('scroll', this.onResizeOrScroll, { passive: true });
      return true;
    }

    destroy() {
      this.root.removeEventListener('mouseenter', this.onMouseEnter);
      this.root.removeEventListener('mousemove', this.onMouseMove);
      this.root.removeEventListener('mouseleave', this.onMouseLeave);
      window.removeEventListener('resize', this.onResizeOrScroll);
      window.removeEventListener('scroll', this.onResizeOrScroll);

      this.hideLayer();
      this.active = false;

      if (this.rafId !== null) {
        window.cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }
    }

    updateMetrics() {
      this.rect = this.root.getBoundingClientRect();
      this.cardHalfWidth = this.card.offsetWidth * 0.5;
      this.cardHalfHeight = this.card.offsetHeight * 0.5;
    }

    onResizeOrScroll() {
      this.updateMetrics();
    }

    onMouseEnter(event) {
      this.updateMetrics();
      this.active = true;

      if (event.target instanceof Element && event.target.closest(HOVER_BLOCKERS_SELECTOR)) {
        this.hideLayer();
      } else {
        this.showLayer();
      }

      this.setTargetFromPointer(event);
      this.currentX = this.targetX;
      this.currentY = this.targetY;
      this.applyTransform();
      this.startLoop();
    }

    onMouseMove(event) {
      if (!this.active) return;

      if (event.target instanceof Element && event.target.closest(HOVER_BLOCKERS_SELECTOR)) {
        this.hideLayer();
        return;
      }

      this.showLayer();
      this.setTargetFromPointer(event);
    }

    onMouseLeave() {
      this.active = false;
      this.hideLayer();

      if (this.rafId !== null) {
        window.cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }
    }

    setTargetFromPointer(event) {
      if (!this.rect) return;

      const localX = event.clientX - this.rect.left;
      const localY = event.clientY - this.rect.top;
      const maxX = Math.max(this.cardHalfWidth, this.rect.width - this.cardHalfWidth);
      const maxY = Math.max(this.cardHalfHeight, this.rect.height - this.cardHalfHeight);

      this.targetX = clamp(localX, this.cardHalfWidth, maxX);
      this.targetY = clamp(localY, this.cardHalfHeight, maxY);
    }

    startLoop() {
      if (this.rafId !== null) return;
      this.rafId = window.requestAnimationFrame(this.tick);
    }

    showLayer() {
      if (this.visible) return;
      this.visible = true;
      this.layer.classList.add('is-visible');
    }

    hideLayer() {
      if (!this.visible) return;
      this.visible = false;
      this.layer.classList.remove('is-visible');
    }

    applyTransform() {
      this.card.style.transform =
        `translate3d(${this.currentX}px, ${this.currentY}px, 0) translate3d(-50%, -50%, 0)`;
    }

    tick() {
      if (!this.active) {
        this.rafId = null;
        return;
      }

      this.currentX += (this.targetX - this.currentX) * this.lerp;
      this.currentY += (this.targetY - this.currentY) * this.lerp;
      this.applyTransform();
      this.rafId = window.requestAnimationFrame(this.tick);
    }
  }

  const initRoot = (root) => {
    if (!root || controllers.has(root)) return;
    const controller = new RichTextCursorRevealController(root);
    if (controller.init()) {
      controllers.set(root, controller);
    }
  };

  const destroyRoot = (root) => {
    const controller = controllers.get(root);
    if (!controller) return;
    controller.destroy();
    controllers.delete(root);
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
  };

  const destroyInSection = (sectionRoot) => {
    if (!sectionRoot) return;
    sectionRoot.querySelectorAll(ROOT_SELECTOR).forEach(destroyRoot);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const sectionRoot = event.target.closest('.shopify-section') || event.target;
    if (!sectionRoot) return;
    destroyInSection(sectionRoot);
    initAll(sectionRoot);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const sectionRoot = event.target.closest('.shopify-section') || event.target;
    destroyInSection(sectionRoot);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["selection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    'use strict';

    if (window.__themeSelectionScrollTransformInitialized) return;
    window.__themeSelectionScrollTransformInitialized = true;

    const SECTION_SELECTOR = '[data-selection-scroll-transform="true"]';
    const CARD_SELECTOR = '[data-selection-scroll-card]';
    const MOTION_SELECTOR = '[data-selection-scroll-motion]';
    const PIN_WRAP_SELECTOR = '[data-selection-pin-wrap]';
    const PIN_ACTIVE_CLASS = 'selection--scroll-pin-active';
    const START_VISIBLE_RATIO = 0.75;
    const OFFSET_PX = 440;
    const HIDDEN_OFFSET_MULTIPLIER = 0.68;
    const PROGRESS_LERP = 0.2;

    const sections = new Set();
    const visibleSections = new Set();
    const stateBySection = new WeakMap();
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const desktopQuery = window.matchMedia('(min-width: 1000px)');
    let rafId = null;
    let visibilityObserver = null;
    const supportsIO = typeof window.IntersectionObserver === 'function';

    const animationsAllowed = () =>
      document.body?.dataset.enableThemeAnimations !== 'false' && !reducedMotionQuery.matches && desktopQuery.matches;

    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
    const easeInOutCubic = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
    const getHiddenOffsetPx = () => {
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 800;
      return Math.max(OFFSET_PX + 140, viewportHeight * HIDDEN_OFFSET_MULTIPLIER);
    };

    const collectSections = (scope) => {
      if (!scope) return [];

      const targets = new Set();

      if (scope instanceof Element && scope.matches(SECTION_SELECTOR)) {
        targets.add(scope);
      }

      scope.querySelectorAll?.(SECTION_SELECTOR).forEach((section) => targets.add(section));

      return Array.from(targets);
    };

    const resetMotionVars = (state) => {
      if (!state) return;
      state.motions.forEach((motion) => {
        motion.style.setProperty('--selection-scroll-y', '0px');
        motion.style.setProperty('--selection-scroll-scale', '1');
      });
      state.renderProgress = 0;
    };

    const setPreparedState = (state) => {
      if (!state) return;
      const hiddenOffsetPx = getHiddenOffsetPx();
      state.motions.forEach((motion, index) => {
        const initialOffset = index === 0 ? OFFSET_PX : hiddenOffsetPx;
        motion.style.setProperty('--selection-scroll-y', `${initialOffset}px`);
        motion.style.setProperty('--selection-scroll-scale', index === 0 ? '0.988' : '0.985');
      });
      state.renderProgress = 0;
    };

    const setPinActive = (section, state, active) => {
      if (!state?.pinEnabled) return;
      section.classList.toggle(PIN_ACTIVE_CLASS, active);
    };

    const getSectionProgress = (section, state) => {
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const startLine = viewportHeight * START_VISIBLE_RATIO;

      if (state?.pinEnabled && state.pinWrap) {
        const rect = state.pinWrap.getBoundingClientRect();
        const scrollable = Math.max(1, state.pinWrap.offsetHeight - viewportHeight);
        const scrolled = clamp(startLine - rect.top, 0, scrollable);
        return clamp(scrolled / scrollable, 0, 1);
      }

      const rect = section.getBoundingClientRect();
      const endLine = viewportHeight * 0.2;
      const totalRange = Math.max(1, rect.height + (startLine - endLine));
      const scrolled = startLine - rect.top;
      return clamp(scrolled / totalRange, 0, 1);
    };

    const ensureSection = (section) => {
      if (!(section instanceof Element) || stateBySection.has(section)) return;

      const cards = Array.from(section.querySelectorAll(CARD_SELECTOR));
      if (!cards.length) return;

      const motions = cards
        .map((card) => card.querySelector(MOTION_SELECTOR))
        .filter((motion) => motion instanceof Element);

      if (!motions.length) return;

      const pinEnabled = section.dataset.selectionPin === 'true';
      const pinWrap = pinEnabled ? section.querySelector(PIN_WRAP_SELECTOR) : null;

      stateBySection.set(section, {
        motions,
        pinEnabled,
        pinWrap,
      });
      sections.add(section);
      if (supportsIO) {
        ensureVisibilityObserver();
        visibilityObserver.observe(section);
      } else {
        visibleSections.add(section);
      }
    };

    const ensureVisibilityObserver = () => {
      if (visibilityObserver) return;
      visibilityObserver = new IntersectionObserver(
        (entries) => {
          let needsUpdate = false;
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (!visibleSections.has(entry.target)) {
                visibleSections.add(entry.target);
                needsUpdate = true;
              }
            } else {
              visibleSections.delete(entry.target);
            }
          });
          if (needsUpdate) requestUpdate();
        },
        { rootMargin: '320px 0px 320px 0px', threshold: 0 }
      );
    };

    const removeSection = (section) => {
      if (!sections.has(section)) return;
      if (visibilityObserver) visibilityObserver.unobserve(section);
      visibleSections.delete(section);
      const state = stateBySection.get(section);
      if (state) {
        setPinActive(section, state, false);
        resetMotionVars(state);
        stateBySection.delete(section);
      }
      sections.delete(section);
    };

    const updateSection = (section, state) => {
      const targetProgress = getSectionProgress(section, state);
      const previousProgress = Number.isFinite(state.renderProgress) ? state.renderProgress : 0;
      let progress = previousProgress + (targetProgress - previousProgress) * PROGRESS_LERP;
      if (Math.abs(targetProgress - progress) < 0.0009) {
        progress = targetProgress;
      }
      state.renderProgress = progress;

      const cardCount = state.motions.length;
      const band = 1 / Math.max(cardCount, 1);
      const hiddenOffsetPx = getHiddenOffsetPx();

      state.motions.forEach((motion, index) => {
        const start = index * band;
        const end = (index + 1) * band;
        const t = clamp((progress - start) / (end - start), 0, 1);
        const eased = easeInOutCubic(t);
        const unlocked = index === 0 || progress >= start;
        const translateY = unlocked ? OFFSET_PX * (1 - eased) : hiddenOffsetPx;
        const scale = unlocked ? 0.988 + eased * 0.012 : 0.985;
        motion.style.setProperty('--selection-scroll-y', `${translateY.toFixed(2)}px`);
        motion.style.setProperty('--selection-scroll-scale', scale.toFixed(4));
      });

      return Math.abs(targetProgress - progress) > 0.0015;
    };

    const updateAll = () => {
      rafId = null;
      const allowMotion = animationsAllowed();
      let needsNextFrame = false;

      sections.forEach((section) => {
        if (!document.contains(section)) {
          removeSection(section);
          return;
        }

        const state = stateBySection.get(section);
        if (!state) return;

        if (!allowMotion) {
          setPinActive(section, state, false);
          resetMotionVars(state);
          return;
        }

        // Skip layout-thrashing rect reads for sections that are nowhere near
        // the viewport. The IO observer will requestUpdate() once they enter.
        if (supportsIO && !visibleSections.has(section)) {
          setPinActive(section, state, true);
          return;
        }

        setPinActive(section, state, true);
        const sectionNeedsMore = updateSection(section, state);
        if (sectionNeedsMore) {
          needsNextFrame = true;
        }
      });

      if (needsNextFrame) {
        requestUpdate();
      }
    };

    const requestUpdate = () => {
      if (rafId) return;
      rafId = window.requestAnimationFrame(updateAll);
    };

    const mount = (scope = document) => {
      collectSections(scope).forEach((section) => {
        ensureSection(section);
        const state = stateBySection.get(section);
        if (!state) return;

        if (!animationsAllowed()) {
          setPinActive(section, state, false);
          resetMotionVars(state);
          return;
        }

        setPinActive(section, state, true);
        setPreparedState(state);
      });
      requestUpdate();
    };

    const unmount = (scope) => {
      collectSections(scope).forEach((section) => removeSection(section));
      requestUpdate();
    };

    // Only fire the global scroll handler when at least one selection section
    // is in (or near) the viewport. Prevents per-scroll work on pages that
    // contain no selection sections, or while the user is scrolled far away.
    const onGlobalScroll = () => {
      if (!sections.size) return;
      if (supportsIO && visibleSections.size === 0) return;
      requestUpdate();
    };
    window.addEventListener('scroll', onGlobalScroll, { passive: true });
    window.addEventListener('resize', requestUpdate);

    document.addEventListener('shopify:section:load', (event) => {
      mount(event.target);
    });

    document.addEventListener('shopify:section:reorder', (event) => {
      mount(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      unmount(event.target);
    });

    reducedMotionQuery.addEventListener?.('change', () => {
      requestUpdate();
    });

    desktopQuery.addEventListener?.('change', () => {
      requestUpdate();
    });

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          mount(document);
        },
        { once: true }
      );
    } else {
      mount(document);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-collection"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';

  if (window.__themeShopByCollectionV2Initialized) return;
  window.__themeShopByCollectionV2Initialized = true;

  const SECTION_SELECTOR = '[data-sbc-root]';
  const registry = new WeakMap();

  class ShopByCollectionHero {
    constructor(root) {
      this.root = root;
      this.items = Array.from(root.querySelectorAll('[data-sbc-target]'));
      this.slides = Array.from(root.querySelectorAll('[data-sbc-bg]'));
      this.defaultSlide = root.querySelector('[data-sbc-bg-default]');
      this.dots = Array.from(root.querySelectorAll('[data-sbc-dot]'));
      this.hoverEnabled = root.dataset.sbcHoverEnabled !== 'false';
      this.resetDefault = root.dataset.sbcResetDefault !== 'false';
      this.hasDefaultBg = root.dataset.sbcHasDefaultBg === 'true' && this.defaultSlide;
      this.defaultIndex = Number.parseInt(root.dataset.sbcDefaultIndex || '1', 10);
      this.defaultIndex = Number.isFinite(this.defaultIndex) && this.defaultIndex > 0 ? this.defaultIndex : 1;
      this.handlers = [];

      if (!this.items.length) return;

      this.bindEvents();
      this.activate(this.defaultIndex, { showDefault: this.hasDefaultBg });
    }

    bindEvents() {
      this.on(this.root, 'focusin', (event) => {
        if (!(event.target instanceof Element)) return;
        const item = event.target.closest('[data-sbc-target]');
        if (!item || !this.root.contains(item)) return;
        const index = Number.parseInt(item.dataset.sbcTarget || '', 10);
        if (!Number.isFinite(index)) return;
        this.activate(index);
      });

      if (this.hoverEnabled) {
        this.on(this.root, 'pointerover', (event) => {
          if (!(event.target instanceof Element)) return;
          if (event.pointerType === 'touch') return;
          const item = event.target.closest('[data-sbc-target]');
          if (!item || !this.root.contains(item)) return;
          const index = Number.parseInt(item.dataset.sbcTarget || '', 10);
          if (!Number.isFinite(index)) return;
          this.activate(index);
        });

        this.on(this.root, 'pointerleave', () => {
          if (!this.resetDefault || !this.hasDefaultBg) return;
          this.activate(this.defaultIndex, { showDefault: true });
        });

        this.on(this.root, 'focusout', (event) => {
          if (!this.resetDefault || !this.hasDefaultBg) return;
          if (this.root.contains(event.relatedTarget)) return;
          this.activate(this.defaultIndex, { showDefault: true });
        });
      }

      this.on(this.root, 'pointerdown', (event) => {
        if (!(event.target instanceof Element)) return;
        const item = event.target.closest('[data-sbc-target]');
        if (!item || !this.root.contains(item)) return;
        const index = Number.parseInt(item.dataset.sbcTarget || '', 10);
        if (!Number.isFinite(index)) return;
        this.activate(index);
      });
    }

    activate(index, { showDefault = false } = {}) {
      if (!Number.isFinite(index) || index < 1) return;

      this.items.forEach((item) => {
        const itemIndex = Number.parseInt(item.dataset.sbcTarget || '', 10);
        const isActive = itemIndex === index;
        item.classList.toggle('is-active', isActive);
        if (isActive) {
          item.setAttribute('aria-current', 'true');
        } else {
          item.removeAttribute('aria-current');
        }
      });

      this.slides.forEach((slide) => slide.classList.remove('is-active'));
      if (this.defaultSlide) this.defaultSlide.classList.remove('is-active');

      if (showDefault && this.hasDefaultBg) {
        this.defaultSlide.classList.add('is-active');
        this.root.classList.remove('has-hover');
      } else {
        const target = this.root.querySelector(`[data-sbc-bg="${index}"]`);
        if (target) {
          target.classList.add('is-active');
        } else if (this.defaultSlide) {
          this.defaultSlide.classList.add('is-active');
        }
        this.root.classList.add('has-hover');
      }

      this.dots.forEach((dot) => {
        const dotIndex = Number.parseInt(dot.dataset.sbcDot || '', 10);
        dot.classList.toggle('is-active', dotIndex === index);
      });

    }

    on(element, eventName, handler) {
      element.addEventListener(eventName, handler);
      this.handlers.push({ element, eventName, handler });
    }

    destroy() {
      this.handlers.forEach(({ element, eventName, handler }) => {
        element.removeEventListener(eventName, handler);
      });
      this.handlers = [];
    }
  }

  const initSection = (root) => {
    if (!(root instanceof HTMLElement)) return;
    if (registry.has(root)) {
      registry.get(root).destroy();
      registry.delete(root);
    }
    registry.set(root, new ShopByCollectionHero(root));
  };

  const destroySection = (root) => {
    if (!(root instanceof HTMLElement)) return;
    if (!registry.has(root)) return;
    registry.get(root).destroy();
    registry.delete(root);
  };

  const resolveFromTarget = (target) => {
    if (!(target instanceof HTMLElement)) return null;
    if (target.matches(SECTION_SELECTOR)) return target;
    return target.querySelector(SECTION_SELECTOR);
  };

  const bootstrap = () => {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const sectionRoot = resolveFromTarget(event.target);
    if (sectionRoot) initSection(sectionRoot);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const sectionRoot = resolveFromTarget(event.target);
    if (sectionRoot) destroySection(sectionRoot);
  });

  document.addEventListener('shopify:section:reorder', (event) => {
    const sectionRoot = resolveFromTarget(event.target);
    if (sectionRoot) initSection(sectionRoot);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';

  if (window.__themeVideoSectionInitialized) return;
  window.__themeVideoSectionInitialized = true;

  const SECTION_SELECTOR = '[data-video-section]';
  const MODAL_SELECTOR = '[data-video-modal]';
  const OPEN_SELECTOR = '[data-video-open]';
  const CLOSE_SELECTOR = '[data-video-close]';
  const PANEL_SELECTOR = '[data-video-modal-panel]';
  const EXTERNAL_CONTAINER_SELECTOR = '[data-video-external-container]';
  const EXTERNAL_TEMPLATE_SELECTOR = '[data-video-external-template]';
  const MEDIA_SELECTOR = '.section-video__media';
  const REDUCED_MOTION_QUERY = window.matchMedia('(prefers-reduced-motion: reduce)');
  const TILT_MOBILE_BREAKPOINT = 700;

  const LOCAL_LOCK_ATTR = 'data-theme-video-modal-lock-count';
  const LOCAL_LOCK_CLASS = 'theme-video-modal-lock';
  const GLOBAL_LOCK_ATTR = 'data-theme-scroll-lock-count';
  const GLOBAL_LOCK_CLASS = 'theme-scroll-lock-active';
  const SCROLLBAR_VAR = '--theme-scrollbar-compensation';

  const DEFAULT_CLOSE_DURATION = 500;
  const controllers = new Map();

  const parseDurationMs = (rawValue) => {
    if (!rawValue) return NaN;
    const value = rawValue.trim();
    if (value.endsWith('ms')) return Number.parseFloat(value);
    if (value.endsWith('s')) return Number.parseFloat(value) * 1000;
    return Number.parseFloat(value);
  };

  const getCloseDuration = (element) => {
    const duration = parseDurationMs(
      getComputedStyle(element || document.documentElement).getPropertyValue('--motion-duration-normal')
    );
    return Number.isFinite(duration) && duration > 0 ? duration : DEFAULT_CLOSE_DURATION;
  };

  const getScrollbarCompensation = () =>
    Math.max(0, window.innerWidth - document.documentElement.clientWidth);

  const acquireGlobalScrollLock = () => {
    const root = document.documentElement;
    const body = document.body;
    const current = Number.parseInt(root.getAttribute(GLOBAL_LOCK_ATTR) || '0', 10);

    if (current <= 0) {
      const compensation = `${getScrollbarCompensation()}px`;
      root.style.setProperty(SCROLLBAR_VAR, compensation);
      if (body) body.style.setProperty(SCROLLBAR_VAR, compensation);
      root.classList.add(GLOBAL_LOCK_CLASS);
      if (body) body.classList.add(GLOBAL_LOCK_CLASS);
    }

    root.setAttribute(GLOBAL_LOCK_ATTR, String(current + 1));
  };

  const releaseGlobalScrollLock = () => {
    const root = document.documentElement;
    const body = document.body;
    const current = Number.parseInt(root.getAttribute(GLOBAL_LOCK_ATTR) || '0', 10);
    const next = Math.max(0, current - 1);

    if (next === 0) {
      root.classList.remove(GLOBAL_LOCK_CLASS);
      if (body) body.classList.remove(GLOBAL_LOCK_CLASS);
      root.removeAttribute(GLOBAL_LOCK_ATTR);
      root.style.removeProperty(SCROLLBAR_VAR);
      if (body) body.style.removeProperty(SCROLLBAR_VAR);
      return;
    }

    root.setAttribute(GLOBAL_LOCK_ATTR, String(next));
  };

  const lockScroll = () => {
    const root = document.documentElement;
    const body = document.body;
    const current = Number.parseInt(root.getAttribute(LOCAL_LOCK_ATTR) || '0', 10);

    if (current <= 0) {
      root.classList.add(LOCAL_LOCK_CLASS);
      if (body) body.classList.add(LOCAL_LOCK_CLASS);
      acquireGlobalScrollLock();
    }

    root.setAttribute(LOCAL_LOCK_ATTR, String(current + 1));
  };

  const unlockScroll = () => {
    const root = document.documentElement;
    const body = document.body;
    const current = Math.max(0, Number.parseInt(root.getAttribute(LOCAL_LOCK_ATTR) || '0', 10));
    const next = Math.max(0, current - 1);

    if (next === 0) {
      root.classList.remove(LOCAL_LOCK_CLASS);
      if (body) body.classList.remove(LOCAL_LOCK_CLASS);
      root.removeAttribute(LOCAL_LOCK_ATTR);
      releaseGlobalScrollLock();
      return;
    }

    root.setAttribute(LOCAL_LOCK_ATTR, String(next));
  };

  class VideoSectionController {
    constructor(root) {
      this.root = root;
      this.modal = root.querySelector(MODAL_SELECTOR);
      this.panel = root.querySelector(PANEL_SELECTOR);
      this.openButtons = Array.from(root.querySelectorAll(OPEN_SELECTOR));
      this.closeButtons = [];

      this.externalContainer = this.modal?.querySelector(EXTERNAL_CONTAINER_SELECTOR) || null;
      this.externalTemplate = this.modal?.querySelector(EXTERNAL_TEMPLATE_SELECTOR) || null;
      this.hostedVideo = this.modal?.querySelector('video') || null;
      this.mediaElement = root.querySelector(MEDIA_SELECTOR);

      this.isOpen = false;
      this.closeTimer = null;
      this.lastTrigger = null;
      this.tiltRaf = null;
      this.tiltActive = true;
      this.intersectionObserver = null;

      this.onOpenClick = this.onOpenClick.bind(this);
      this.onCloseClick = this.onCloseClick.bind(this);
      this.onDocumentKeydown = this.onDocumentKeydown.bind(this);
      this.onViewportChange = this.onViewportChange.bind(this);
      this.onReducedMotionChange = this.onReducedMotionChange.bind(this);
    }

    init() {
      if (!this.modal || !this.panel || !this.openButtons.length) return false;

      this.closeButtons = Array.from(this.root.querySelectorAll(CLOSE_SELECTOR));

      this.openButtons.forEach((btn) => btn.addEventListener('click', this.onOpenClick));
      this.closeButtons.forEach((btn) => btn.addEventListener('click', this.onCloseClick));
      document.addEventListener('keydown', this.onDocumentKeydown);
      window.addEventListener('scroll', this.onViewportChange, { passive: true });
      window.addEventListener('resize', this.onViewportChange);
      if (REDUCED_MOTION_QUERY.addEventListener) {
        REDUCED_MOTION_QUERY.addEventListener('change', this.onReducedMotionChange);
      } else if (REDUCED_MOTION_QUERY.addListener) {
        REDUCED_MOTION_QUERY.addListener(this.onReducedMotionChange);
      }

      // Tilt readouts read getBoundingClientRect every scroll. Only do that
      // while the section is actually near the viewport.
      if (typeof window.IntersectionObserver === 'function') {
        this.tiltActive = false;
        this.intersectionObserver = new IntersectionObserver((entries) => {
          const wasActive = this.tiltActive;
          this.tiltActive = entries.some((entry) => entry.isIntersecting);
          if (this.tiltActive && !wasActive) {
            this.queueTiltUpdate();
          } else if (!this.tiltActive && wasActive) {
            this.resetTiltTransform();
          }
        }, { rootMargin: '320px 0px 320px 0px', threshold: 0 });
        this.intersectionObserver.observe(this.root);
      }

      this.queueTiltUpdate();

      return true;
    }

    destroy() {
      this.openButtons.forEach((btn) => btn.removeEventListener('click', this.onOpenClick));
      this.closeButtons.forEach((btn) => btn.removeEventListener('click', this.onCloseClick));
      document.removeEventListener('keydown', this.onDocumentKeydown);
      window.removeEventListener('scroll', this.onViewportChange);
      window.removeEventListener('resize', this.onViewportChange);
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
        this.intersectionObserver = null;
      }
      if (REDUCED_MOTION_QUERY.removeEventListener) {
        REDUCED_MOTION_QUERY.removeEventListener('change', this.onReducedMotionChange);
      } else if (REDUCED_MOTION_QUERY.removeListener) {
        REDUCED_MOTION_QUERY.removeListener(this.onReducedMotionChange);
      }
      if (this.tiltRaf) {
        window.cancelAnimationFrame(this.tiltRaf);
        this.tiltRaf = null;
      }
      this.resetTiltTransform();
      window.clearTimeout(this.closeTimer);

      if (this.isOpen) {
        this.isOpen = false;
        unlockScroll();
      }

      this.unmountExternalVideo();
      this.pauseHostedVideo();

      if (this.modal) {
        this.modal.classList.remove('is-open', 'is-opening', 'is-closing');
        this.modal.setAttribute('aria-hidden', 'true');
        this.modal.setAttribute('hidden', '');
      }
    }

    onOpenClick(event) {
      event.preventDefault();
      this.open(event.currentTarget);
    }

    onCloseClick(event) {
      event.preventDefault();
      this.close(true);
    }

    onDocumentKeydown(event) {
      if (event.key !== 'Escape' || !this.isOpen) return;
      event.stopPropagation();
      this.close(true);
    }

    open(trigger) {
      if (this.isOpen || !this.modal) return;

      this.isOpen = true;
      this.lastTrigger = trigger instanceof HTMLElement ? trigger : null;
      window.clearTimeout(this.closeTimer);

      this.mountExternalVideo();

      this.modal.removeAttribute('hidden');
      this.modal.setAttribute('aria-hidden', 'false');
      this.modal.classList.remove('is-closing', 'is-opening', 'is-open');

      void this.modal.offsetHeight;

      this.modal.classList.add('is-opening');
      lockScroll();

      window.requestAnimationFrame(() => {
        this.modal.classList.remove('is-opening');
        this.modal.classList.add('is-open');
        this.playHostedVideo();

        const closeButton = this.modal.querySelector(CLOSE_SELECTOR);
        if (closeButton instanceof HTMLElement) {
          closeButton.focus({ preventScroll: true });
        } else {
          this.panel.focus({ preventScroll: true });
        }
      });
    }

    close(restoreFocus) {
      if (!this.isOpen || !this.modal) return;

      this.isOpen = false;
      const duration = getCloseDuration(this.panel);

      this.modal.classList.remove('is-open', 'is-opening');
      this.modal.classList.add('is-closing');
      this.modal.setAttribute('aria-hidden', 'true');

      this.pauseHostedVideo();
      this.unmountExternalVideo();
      unlockScroll();

      window.clearTimeout(this.closeTimer);
      this.closeTimer = window.setTimeout(() => {
        this.modal.classList.remove('is-closing');
        this.modal.setAttribute('hidden', '');
      }, duration + 50);

      if (restoreFocus && this.lastTrigger && typeof this.lastTrigger.focus === 'function') {
        window.requestAnimationFrame(() => {
          this.lastTrigger.focus({ preventScroll: true });
        });
      }
    }

    playHostedVideo() {
      if (!(this.hostedVideo instanceof HTMLVideoElement)) return;
      this.hostedVideo.currentTime = 0;
      const p = this.hostedVideo.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});
    }

    pauseHostedVideo() {
      if (!(this.hostedVideo instanceof HTMLVideoElement)) return;
      this.hostedVideo.pause();
      this.hostedVideo.currentTime = 0;
    }

    mountExternalVideo() {
      if (!this.externalContainer || !this.externalTemplate) return;
      if (this.externalContainer.childElementCount > 0) return;
      this.externalContainer.replaceChildren(this.externalTemplate.content.cloneNode(true));
    }

    unmountExternalVideo() {
      if (!this.externalContainer) return;
      if (this.externalContainer.childElementCount === 0) return;
      this.externalContainer.replaceChildren();
    }

    onViewportChange() {
      if (!this.tiltActive) return;
      this.queueTiltUpdate();
    }

    onReducedMotionChange() {
      this.queueTiltUpdate();
    }

    queueTiltUpdate() {
      if (this.tiltRaf) return;
      this.tiltRaf = window.requestAnimationFrame(() => {
        this.tiltRaf = null;
        this.updateScrollTilt();
      });
    }

    resetTiltTransform() {
      if (!(this.mediaElement instanceof HTMLElement)) return;
      this.mediaElement.style.setProperty('--video-tilt-rotate-x', '0deg');
      this.mediaElement.style.setProperty('--video-tilt-translate-y', '0px');
      this.mediaElement.style.setProperty('--video-tilt-scale', '1');
    }

    updateScrollTilt() {
      if (!(this.mediaElement instanceof HTMLElement)) return;

      const isDesktop = window.innerWidth >= TILT_MOBILE_BREAKPOINT;
      if (!isDesktop || REDUCED_MOTION_QUERY.matches) {
        this.resetTiltTransform();
        return;
      }

      const rect = this.root.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      const revealDistance = Math.max(1, rect.height * 0.5);
      const progress = Math.min(Math.max((viewportHeight - rect.top) / revealDistance, 0), 1);
      const strength = 1 - progress;

      const rotateX = (strength * 70).toFixed(3);
      const translateY = (strength * 30).toFixed(2);
      const scale = (1 - (strength * 0.04)).toFixed(4);

      this.mediaElement.style.setProperty('--video-tilt-rotate-x', `${rotateX}deg`);
      this.mediaElement.style.setProperty('--video-tilt-translate-y', `${translateY}px`);
      this.mediaElement.style.setProperty('--video-tilt-scale', scale);
    }
  }

  const initRoot = (root) => {
    if (!root || controllers.has(root)) return;
    const controller = new VideoSectionController(root);
    if (controller.init()) controllers.set(root, controller);
  };

  const destroyRoot = (root) => {
    const controller = controllers.get(root);
    if (!controller) return;
    controller.destroy();
    controllers.delete(root);
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll(SECTION_SELECTOR).forEach(initRoot);
  };

  const destroyInSection = (sectionRoot) => {
    if (!sectionRoot) return;
    sectionRoot.querySelectorAll(SECTION_SELECTOR).forEach(destroyRoot);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const sectionRoot = event.target.closest('.shopify-section') || event.target;
    if (!sectionRoot) return;
    destroyInSection(sectionRoot);
    initAll(sectionRoot);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const sectionRoot = event.target.closest('.shopify-section') || event.target;
    destroyInSection(sectionRoot);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
